/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'



import Landing from '@/components/landing/Landing'

import Login from '@/components/user/Login'
import Profile from '@/components/user/Profile'
import CreateAccount from '@/components/user/CreateAccount'
import DeleteAccount from '@/components/user/DeleteAccount'
import Privacy from '@/components/user/Privacy'
import SpeechToText from '@/components/SpeechToText'

import SAP_Account from '@/components/SAP_Account'
import Einsicht from '@/components/Einsicht'
import Tests from '@/components/quiz/Test'

import Chat from '@/components/Chat'
import Formulare from '@/components/Formulare'
import Admin from '@/components/admin/Admin'



import store from './../store/store';
const config = require('./../classes/myConfig').config;

Vue.use(Router)

const r = new Router({
    mode: 'history',
    routes: [
        {
            path: '*',
            redirect: '/landing',
        },
        {
            path: '/landing',
            name: 'landing',
            component: Landing,
        },
        {
            path: '/createaccount',
            name: 'createaccount',
            component: CreateAccount,
            meta: {
                requiresSignOut: true,
                requiresOnlyFromLanding: true,
            }

        },
        {
            path: '/deleteaccount',
            name: 'deleteaccount',
            component: DeleteAccount,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: Privacy,
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                requiresSignOut: true
            }
        },

        {
            path: '/profile',
            name: 'profile',
            component: Profile,
            meta: {
                requiresAuth: true,
                requiresOnlyFromLanding: true,
            }
        },
        {
            path: '/speechtotext',
            name: 'speechtotext',
            component: SpeechToText,
            meta: {
                requiresAuth: false
            }
        },

        {
            path: '/chatbot',
            name: 'chatbot',
            component: Chat,
            meta: {
                requiresAuth: false
            }
        },

        {
            path: '/ecc',
            name: 'ecc',
            component: SAP_Account,
            meta: {
                requiresAuth: true
            }
        },

        {
            path: '/it3formulare',
            name: 'it3formulare',
            component: Formulare,
            meta: {
                requiresAuth: false
            }
        },

        {
            path: '/admin',
            name: 'admin',
            component: Admin,
            meta: {
                requiresAdmin: true
            }
        },

        {
            path: '/einsicht',
            name: 'einsicht',
            component: Einsicht,
            meta: {
                requiresAuth: true
            }
        },

        {
            path: '/tests',
            name: 'tests',
            component: Tests,
            meta: {
                requiresAuth: true
            }
        },

        {
            path: '/vpsap',
            name: 'vpsap',
            beforeEnter(to, from, next) {
                // Put the full page url including the protocol http(s) below
                // window.location = "/books/" �ffnet im gleichen Fenster 
                var s = config.getBaseUrl() + 'books/test/index.html';
                console.log("ROUTER.JS : " + "BaseUrl : " + s);
                var win = window.open(s, '_blank');
                win.focus();
            }
        }
    ]
});

r.beforeEach((to, from, next) => {

    const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
    const requiresSignOut = to.matched.some(x => x.meta.requiresSignOut);
    const requiresOnlyFromLanding = to.matched.some(x => x.meta.requiresOnlyFromLanding);
    const requiresAdmin = to.matched.some(x => x.meta.requiresAdmin);


    let redirect = false;

    console.log(" ========== ROUTING CHECK ========== ");

    console.log("ROUTER.JS : " + "ROUTER.beforeEach: From = ." + from.fullPath + ". To = " + to.fullPath);



    if (requiresOnlyFromLanding) {
        console.log("ROUTER.JS : " + "   Global Route Gard: Check if we come from landing");
        if (!(from.fullPath == "/landing")) {
            console.log("                " + "  Blocked.");
            next('/landing');
        } else {
            console.log("                " + "  Passed.");
        }
    }

    if (requiresAdmin) {
        console.log("ROUTER.JS : " + "   Global Route Gard: Check if user is admkin.");
        if (!store.getters.isAdmin) {
            next('/landing');
            return;
        }
        console.log("     ... yes, is admin");
        
    }

    if (requiresAuth) {
        console.log("ROUTER.JS : " + "   Global Route Gard: Check if user is active (auth + email verified).");
        let user = store.getters.user;
        if (user && user.emailVerified) {
            console.log("                " + " Passed");
            console.log("                       User :" + store.getters.user.email);
            console.log("              Mail verified :" + store.getters.user.emailVerified);

        } else {
            console.log("                " + "  Blocked.");
            redirect = true;
            next('/landing');
            return;
        }
    }

    // We need state where a user is not active
    if (requiresSignOut) {
        console.log("ROUTER.JS : " + "   Global Route Gard: Check, if user is signed out."
            + JSON.stringify(store.getters.user));
        if (store.getters.isUserActive) {
            console.log("ROUTER.JS : " + "   Global Route Gard: Check is user is NOT authenticaed.");
            console.log("ROUTER.JS : " + "   Router blocked access");
            redirect = true;

            next('/landing');
        }
    }



    console.log("ROUTER.JS : [SUCCESS] All checks passed - no changes to the route.\n\n");
    next();



})


export var router = r;